
function CVideoInfo()
{
    this.source = null;
    this.scale = 1;
    this.rotate = 0;
}

function CMachineInfo()
{
    CMachineInfo.prototype.reset = function()
    {
        this.roomId = null;
        this.deviceId = -1;
        this.machineId = -1;
        this.bMaster = false;
        this.blocked = false;
        this.broken = false;
        this.btnHoldType = [];
        this.btnScoreRatios = [];
        this.btnPinponTimers = [];
        this.btnTexts = [];
        this.btnTypes = [];
        this.gameUI = null;
        this.singleInScore = 0;
        this.bTrial = false;
        this.videoInfos = [];
        this.winAward = false;
    }

    CMachineInfo.prototype.parse = function(config)
    {
        try {
            if (config.hasOwnProperty("RoomID")) this.roomId = config.RoomID;
            if (config.hasOwnProperty("DeviceId")) this.deviceId = config.DeviceId;
            if (config.hasOwnProperty("MachineId")) this.machineId = config.MachineId;
			if (config.hasOwnProperty("BtnTMasterexts")) this.bMaster = config.Master;
			if (config.hasOwnProperty("Blocked")) this.blocked = config.Blocked;
			if (config.hasOwnProperty("Broken")) this.broken = config.Broken;
			if (config.hasOwnProperty("BtnHoldType")) this.btnHoldType = config.BtnHoldType;
			if (config.hasOwnProperty("BtnScoreRatios")) this.btnScoreRatios = config.BtnScoreRatios;
            if (config.hasOwnProperty("BtnPinponTimers")) this.btnPinponTimers = config.BtnPinponTimers;
			if (config.hasOwnProperty("BtnTexts")) this.btnTexts = config.BtnTexts;
			if (config.hasOwnProperty("BtnTypes")) this.btnTypes = config.BtnTypes;
			if (config.hasOwnProperty("GameUI")) this.gameUI = config.GameUI;
			if (config.hasOwnProperty("SingleInScore")) this.singleInScore = config.SingleInScore;
			if (config.hasOwnProperty("Trial")) this.bTrial = config.Trial;

            this.videoInfos = [];
            for (let i = 0 ; i < 3 ; i++) {
                const videoInfo = new CVideoInfo();
                switch (i) {
                    case 0:
                        if (config.hasOwnProperty("VideoSource")) videoInfo.source = config.VideoSource;
                        if (config.hasOwnProperty("CameraScale")) videoInfo.scale = config.CameraScale;
                        if (config.hasOwnProperty("VideoAngle")) videoInfo.rotate = config.VideoAngle;
                        break;
                    case 1:
                        if (config.hasOwnProperty("VideoSource1")) videoInfo.source = config.VideoSource1;
                        if (config.hasOwnProperty("CameraScale1")) videoInfo.scale = config.CameraScale1;
                        if (config.hasOwnProperty("VideoAngle1")) videoInfo.rotate = config.VideoAngle1;
                        break;
                    case 2:
                        if (config.hasOwnProperty("VideoSource2")) videoInfo.source = config.VideoSource2;
                        if (config.hasOwnProperty("CameraScale2")) videoInfo.scale = config.CameraScale2;
                        if (config.hasOwnProperty("VideoAngle2")) videoInfo.rotate = config.VideoAngle2;
                        break;
                }
                this.videoInfos.push(videoInfo);
            }
            
            return true;
        }
        catch(error) {
            console.log(error);
        }
        return false;
    }
}

module.exports = {
    create: function() {
        const machineInfo = new CMachineInfo();
        machineInfo.reset();
        return machineInfo;
    }
};